import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { enumCronStatuses, FINANCE_TYPE, QUICKBOOKS_TYPE, SHOPIFY_AMAZON_INVENTORY } from "../consts/cronTypes";
import ReactTooltip from "react-tooltip";
import { useEffect } from "react";
import { LoaderSpinner } from "./LoaderSpinner";
import { formatDateByGMT } from "../helpers/formatDateByGMT";
import { getCronStatusColor } from "../helpers/common";

export const CronUpdatesBlock = ({
    status,
    type,
    updatedDate,
    errorText,
    isLoading,
    testId
}) => {
    const getTypeTitle = () => 
            type === FINANCE_TYPE ? "Finance cron" : 
            type === QUICKBOOKS_TYPE ? "QuickBooks cron" : 
            type === SHOPIFY_AMAZON_INVENTORY ? "Stock Levels cron" :
            null;
    useEffect(() => {
        ReactTooltip.rebuild()
    }, [])
    return (
        <section className="bg-white p-2 rounded-lg shadow w-auto max-w-72 flex" data-testid={testId}>
          <div className="flex gap-2 text-base items-center justify-center">
            {isLoading ? (
                <div className="min-w-[200px] my-1.5">
                    <LoaderSpinner border="2" width="12" height="12" colorSpinner="black" type="cron" testId={`loader-spinner-${testId}`}/>
                </div>
            ) : (
                <>
                    <h6 className="font-medium">{getTypeTitle()}:</h6>
                    <div className={`px-3 text-xs py-0.5 rounded-xl ${getCronStatusColor(status)}`} data-testid={`status-${testId}`}>
                        {status ? enumCronStatuses[status] : "N/A"}
                    </div>
                    <ReactTooltip 
                        id={`${type}_tooltip-cron`} 
                        html={true}
                        effect='solid'
                    >
                        {`
                            <div class="w-72">
                                <div>Updated: ${updatedDate ? formatDateByGMT(updatedDate) : "N/A"}</div>
                                ${errorText ? `<div>Error: ${errorText}</div>` : ""}
                            </div>
                        `}
                    </ReactTooltip>
                    <InformationCircleIcon 
                        className='h-5 w-5 text-black-600 hover:text-black-900'
                        data-for={`${type}_tooltip-cron`}
                        data-tip={true}
                        data-testid={`icon-${testId}`}
                    />
                </>
            )}
          </div>
        </section>
    )
}